import add from "date-fns/add";
import isAfter from "date-fns/isAfter";
import setYear from "date-fns/setYear";
import sub from "date-fns/sub";
import { DatePickerDate } from "../../types";

export const canMoveToPreviousMonth = (activeDate: Date, minDate: DatePickerDate | undefined) => {
    if (!minDate) {
        return true;
    }

    const prevMonthDate = sub(activeDate, { months: 1 });
    const minDateObject = convertDatePickerDateToDate(minDate);

    return prevMonthDate >= minDateObject;
};

export const canMoveToNextMonth = (activeDate: Date, maxDate: DatePickerDate | undefined) => {
    if (!maxDate) {
        return true;
    }

    const nextMonthDate = add(activeDate, { months: 1 });
    const maxDateObject = convertDatePickerDateToDate(maxDate);

    return nextMonthDate <= maxDateObject;
};

export const convertDatePickerDateToDate = ({ year, month, day }: DatePickerDate) => {
    return new Date(year, month, day);
};

export const getAdjustedDateOnYearChange = (
    activeDate: Date,
    newYear: number,
    minDate?: DatePickerDate,
    maxDate?: DatePickerDate
) => {
    const newDate = setYear(activeDate, newYear);
    const maxDateObj = maxDate ? convertDatePickerDateToDate(maxDate) : undefined;
    const minDateObj = minDate ? convertDatePickerDateToDate(minDate) : undefined;

    if (maxDateObj && isAfter(newDate, maxDateObj)) {
        return maxDateObj;
    }
    if (minDateObj && isAfter(minDateObj, newDate)) {
        return minDateObj;
    }

    return newDate;
};
